import { taskIsSleeping } from "../../store/taskAttention"
import type { SidebarTaskItem } from "./taskDisplayTypes"

export function isSidebarTaskUnread(task: Pick<SidebarTaskItem, "closed" | "lastActivityAt" | "lastViewedAt" | "attention" | "sleeping">): boolean {
    if (task.sleeping ?? taskIsSleeping(task)) return false
    if (!task.lastActivityAt) return false
    if (!task.lastViewedAt) return true
    return task.lastActivityAt > task.lastViewedAt
}

export function shouldSurfaceSidebarTaskUnread(
    task: Pick<SidebarTaskItem, "closed" | "lastActivityAt" | "lastViewedAt" | "attention" | "sleeping">,
    now = new Date()
): boolean {
    if (!isSidebarTaskUnread(task)) return false
    if (!task.closed) return true

    const activityAt = new Date(task.lastActivityAt ?? "")
    if (!Number.isFinite(activityAt.getTime())) return false

    return activityAt.getFullYear() === now.getFullYear() && activityAt.getMonth() === now.getMonth() && activityAt.getDate() === now.getDate()
}
